import React from "react";
import {useHistory} from "react-router-dom";
import {SwiperSlide} from "swiper/react";
import {parseSliderParams} from "../Util/ComponentHelper";
import DefaultSlider from "../Partials/DefaultSlider";
import CustomSlider from "../Partials/CustomSlider";
import SimpleVideoSlide from "../Partials/Slides/SimpleVideoSlide";
import SliderCardFull from "../Partials/Slides/SlideFull";

const VideoListComponent = ({component}) => {
    const history = useHistory();

    let style = component.parameters?.find(param => param.key === "style")?.value;

    if (style === "bigSlider") {
        return (
            <div className="topBanner_carousel">
                {component.data && component.data.length !== 0 ? (
                    <DefaultSlider autoplay>
                        {component.data.map((item, i) => {
                            let {background, title, textLeft, textRight, callbackUrl, type_id} = parseSliderParams(
                                item,
                                "imgLandscape"
                            );
                            return (
                                <SwiperSlide key={i}>
                                    <SliderCardFull
                                        background={background}
                                        title={title}
                                        textLeft={textLeft}
                                        textRight={textRight}
                                        callback={() => history.push(callbackUrl)}
                                        type_id={type_id}
                                    />
                                </SwiperSlide>
                            );
                        })}
                    </DefaultSlider>
                ) : null}
            </div>
        );
    } else {
        return (
            <div className="d-flex flex-column container">
                <div className="d-flex justify-content-between mt-4">
                    <h3 className="mb-3 home_carousels_title">{component.name}</h3>
                </div>
                <div className="custom-slide">
                    <CustomSlider>
                        {component.data && component.data.length !== 0
                            ? component.data.map((item, i) => {
                                  let {
                                      background,
                                      title,
                                      textLeft,
                                      textRight,
                                      callbackUrl,
                                      type_id,
                                  } = parseSliderParams(item);
                                  return (
                                      <SwiperSlide key={i} className="movieShowcase__container--movie__netflix">
                                          <SimpleVideoSlide
                                              background={background}
                                              title={title}
                                              textLeft={textLeft}
                                              textRight={textRight}
                                              callback={() => history.push(callbackUrl)}
                                              type_id={type_id}
                                          />
                                      </SwiperSlide>
                                  );
                              })
                            : null}
                    </CustomSlider>
                </div>
            </div>
        );
    }
};
export default VideoListComponent;
